import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'app/api.service';

@Component({
  selector: 'app-create-voucher-dialog',
  templateUrl: './create-voucher-dialog.component.html',
  styleUrls: ['./create-voucher-dialog.component.scss']
})
export class CreateVoucherDialogComponent {
  isInputDisabled: boolean = false;
  voucher: string = '';
  description: string = '';
  prefix: string = '';
  cr_no: string = '';
  dr_no: string = '';
  type: string = '';
  viewdata: any;
  button: boolean = true;
  voucher_type = '';
  voucherTypes = ['Inter Branch','Intra Branch','Inter Company','Purchase','Sales','Receipt Voucher','Credit Note','Debit Note','Advance Multibranch','Inventory Voucher','Sales Return','Purchase Return','Salary'];
  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<CreateVoucherDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id?: number; type?: string; name?: string; description?: string; prefix?: string; cr_no?: string; dr_no?: string; voucher_type?: string; }
  ) {
    this.type = data?.type;
    this.voucher = data?.name || '';
    this.description = data?.description || '';
    this.prefix = data?.prefix || '';
    this.cr_no = data?.cr_no || '';
    this.dr_no = data?.dr_no || '';
    this.voucher_type = data?.voucher_type || '';
    if (this.data?.id && this.type == "View") {
      this.button = false;
      this.isInputDisabled = true;
    }
    if (this.data?.id && this.type == "Update") {
      this.button = true; 
    }
  }
  onSave(): void {
    if (!this.prefix) {
      alert('Prefix is required.');
      return;
    }
    const postData = {
      name: this.voucher,
      description: this.description,
      prefix: this.prefix,
      cr_no: this.cr_no ? this.cr_no:0,
      dr_no: this.dr_no ? this.dr_no:0,
      voucher_type: this.voucher_type ? this.voucher_type:'',
    };
    if (this.data?.id) {
      this.apiService.updateVoucher(this.data.id, postData)
        .subscribe(
          updatedVoucher => {
          this.dialogRef.close(this.voucher);
        },
          error => {
            console.error('Error updating voucher:', error);
        }
      );
    } else {
      this.apiService.saveVoucher(postData)
        .subscribe(
          savedVoucher => {
          if (savedVoucher[0].original.status === "fail") {
              alert(savedVoucher[0].original.message)
          } else {
            this.dialogRef.close(this.voucher);
          }
        },
          error => {
            console.error('Error saving voucher:', error);
        }
      );
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}